export default {"src":"/_next/static/media/powerUpTransparent_24.290eab5a.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};